import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import Tooltip from 'components/tooltip/Tooltip.component';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './TimeOffCategoriesHeader.module.scss';

const TimeOffCategoriesHeader = ({ calendarMode }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="TimeOffCategoriesHeader" className={cn(CN.row, CN[calendarMode])}>
      <span className={CN.title}>{t('humanResources.timeOffSettings.categories.headers.categoryName')}</span>
      <span className={CN.title}>{t('humanResources.timeOffSettings.categories.headers.colorInCalendar')}</span>
      <span className={CN.title}>
        <Tooltip title={t('humanResources.timeOffSettings.categories.headers.IncWorkingHours')}>{t('humanResources.timeOffSettings.categories.headers.IncWorkingHoursTooltip')}</Tooltip>
      </span>
      <span className={CN.title}>
        <Tooltip title={t('humanResources.timeOffSettings.categories.headers.defaultAllowance')}>{t('humanResources.timeOffSettings.categories.headers.defaultAllowanceTooltip')}</Tooltip>
      </span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(TimeOffCategoriesHeader);
